import { useEffect, useState } from 'react';

const defaultDelay = 300;

export const useDebounce = <T>(value: T, delay = defaultDelay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};
